import { compact, invert, isArray } from 'lodash';

import { sanitizeQuery } from '@app/components';
import { trimDoubleQuotes, unescapeQuotes } from '@app/utils';

import {
  AdvancedSearchField,
  AdvancedSearchQualifier,
  consortiaFieldsRegex,
  consortiaFieldsToMaskMap,
  consortiaQualifiersRegex,
  consortiaSearchOperatorMap,
  fieldsRegex,
  fieldsToMaskMap,
  qualifiersRegex,
  RowValues,
} from '../constants';

export const parseMaskedFieldQualifierValue = ({
  fieldQualifierValue,
  isConsortiaMode,
}: {
  fieldQualifierValue: string;
  isConsortiaMode?: boolean;
}): RowValues => {
  const regex = isConsortiaMode
    ? new RegExp(
        `^(${consortiaFieldsRegex})(${consortiaQualifiersRegex})(".*")$`
      )
    : new RegExp(`^(${fieldsRegex}) (${qualifiersRegex}) (".*")$`);
  const isQueryStringValid = regex.test(fieldQualifierValue.trim());

  if (!isQueryStringValid) {
    return {
      field: AdvancedSearchField.keyword,
      qualifier: AdvancedSearchQualifier.containsAll,
      value: fieldQualifierValue,
      isInvalid: true,
    };
  }

  const [field, qualifier, ...query] = compact(
    fieldQualifierValue.trim().split(regex)
  );
  const value = trimDoubleQuotes(
    unescapeQuotes(sanitizeQuery(isArray(query) ? query.join('') : query))
  );

  return {
    field: invert(isConsortiaMode ? consortiaFieldsToMaskMap : fieldsToMaskMap)[
      field
    ] as AdvancedSearchField,
    qualifier: (isConsortiaMode
      ? consortiaSearchOperatorMap[qualifier]
      : qualifier) as AdvancedSearchQualifier,
    value,
  };
};
